/**
 * @fileoverview Desktop sidebar for Today view: deadlines, triage, stats.
 */
import { Box } from '@mui/material';
import TodayDeadlinesPanel from '@/features/today/components/TodayDeadlinesPanel';
import TodayStatsRail from './TodayStatsRail';
import TriageHeroCard from './TriageHeroCard';
import { PANEL_GAP } from '@/components/layout/spacingTokens';

/**
 * @param {{
 *   userId?: string,
 *   allTasks: import('@/types').Task[],
 *   tasksMap: Map<string, import('@/types').Task>,
 * }} props
 */
const TodayViewSidebar = ({ userId, allTasks, tasksMap }) => (
  <Box
    sx={{
      flex: '0 0 220px',
      display: 'flex',
      flexDirection: 'column',
      gap: PANEL_GAP,
    }}
  >
    <TodayDeadlinesPanel />
    <TriageHeroCard userId={userId} />
    <TodayStatsRail allTasks={allTasks} tasksMap={tasksMap} />
  </Box>
);

export default TodayViewSidebar;
